/**
 * Canvas helper for Web Worker compatibility
 */

/**
 * 環境に応じて適切なCanvasを作成
 */
export function createCanvas(width: number, height: number): HTMLCanvasElement | OffscreenCanvas {
  // Web Worker環境の場合
  if (typeof OffscreenCanvas !== 'undefined' && typeof document === 'undefined') {
    return new OffscreenCanvas(width, height);
  }

  // ブラウザのメインスレッドの場合
  if (typeof document !== 'undefined') {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  // Node.js環境など（エラー）
  throw new Error('No canvas implementation available');
}

/**
 * 2Dコンテキストを取得
 */
export function getContext2D(canvas: HTMLCanvasElement | OffscreenCanvas): CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D {
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get 2D context');
  }
  return ctx as any;
}